import React from "react";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";
import { Label, Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { deriveFileExtension } from "../../logic/deriveFileExtension";
import { Attachment, bytesToSize } from "../..";
import styles from "./chat-file.module.scss";

type ChatFileProps = { file: Attachment };

const ChatFile = ({ file }: ChatFileProps) => {
  const extension = deriveFileExtension(file.title);

  return (
    <a className={styles.file} href={file.link} target="_blank" download>
      <div className={styles.iconWrapper}>
        <Label size="small" className={styles.extension}>
          {extension}
        </Label>
        <Icon.Monochrome
          className={styles.icon}
          emphasis="white"
          name="file-blank"
        />
      </div>
      <div className={styles.info}>
        <Paragraph size="small" className={styles.name}>
          {file.title}
        </Paragraph>
        {!!file.size && (
          <Paragraph size="small" weight="book" className={styles.size}>
            {bytesToSize(file.size)}
          </Paragraph>
        )}
      </div>
    </a>
  );
};

export default ChatFile;
